routesConfig.$inject = ['$stateProvider']

function routesConfig($stateProvider) {
  $stateProvider
    .state('home.byLastItems', {
      url: "compra-rapida/carga-rapida-por-ultimos-items-comprados",
      template: `<by-last-items sh-ctrl="shCtrl"></by-last-items>`
    })
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** ./www/components/fast-purchase/by-last-items/by-last-items.config.js
 **/